import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { DoppiaMaterialitaService } from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-criterio-assegnazione',
  standalone: false,

  templateUrl: './dialog-criterio-assegnazione.component.html',
  styleUrl: './dialog-criterio-assegnazione.component.scss',
})
export class DialogCriterioAssegnazioneComponent {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public testoCriterio = '';
  public obbligatorio = false;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly utilityService: UtilityService,
    public readonly dialogRef: MatDialogRef<DialogCriterioAssegnazioneComponent>,
    private readonly doppiaMaterialitaService: DoppiaMaterialitaService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      idDoppiaMaterialita: string;
      idCategoria: string;
      tipologia: string;
      testoCriterio?: string;
      obbligatorio?: boolean;
      isDisabled?: boolean;
    },
  ) {}

  ngAfterViewInit(): void {
    this.datiIniziali();
    this.cdRef.detectChanges();
  }

  public datiIniziali() {
    this.testoCriterio = this.data.testoCriterio ?? '';
    this.obbligatorio = !!this.data.obbligatorio;
  }

  public conferma() {
    if (this.obbligatorio && !(this.testoCriterio ?? '').trim()) {
      this.utilityService.openSnackBar(
        'È obbligatorio descrivere i criteri per l’individuazione degli IRO.',
        '',
        {
          duration: 4000,
          panelClass: ['red-snackbar'],
        },
      );
      return;
    }

    this.spinnerOver.show();
    this.doppiaMaterialitaService
      .putCriteriAssegnazioniCategoria(
        this.data.idDoppiaMaterialita,
        this.data.idCategoria,
        this.data.tipologia,
        this.testoCriterio,
      )
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: () => {},
        error: (err) => {
          console.error(err);
        },
      });

    this.dialogRef.close({ salva: true, testoCriterio: this.testoCriterio });
  }

  public chiudi() {
    this.dialogRef.close({ salva: false });
  }
}
